var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import MessageBox from "syf-component-library/ui/patterns/MessageBox/MessageBox";
import { Stack } from "syf-component-library/ui/spacing";
import { Body, Small } from "syf-component-library/ui/typography";
import EnrollmentLogo from "./EnrollmentLogo";
import { ConsentLink, ErrorImage, NotEnrolledBody, NotEnrolledTemplate, } from "./subcomponents";
import { PAGE_NAME } from "../../../const/analytics";
import endPoints from "../../../const/endpoints";
import { enrollmentType as enrollmentTypes } from "../../../const/enrollmentConsts";
import icons from "../../../const/icons";
import { useAccountFeatures, useAccountSummary, } from "../../../const/syfApiQueries";
import { useStatementsContext } from "../../../context/statementsContext";
import getConsentLinks from "../../../helpers/getConsentLinks";
import getPaperFeeApplicable from "../../../helpers/getPaperFeeApplicable";
import getPaperFeeMessage from "../../../helpers/getPaperFeeMessage";
import ToggleShowEnrollmentErrorHook from "../../../helpers/toggleShowEnrollmentError";
import triggerAnalytics from "../../../helpers/triggerAnalytics";
import { useConfig } from "../../../hooks/useConfig";
import StatementsTrans from "../../atoms/StatementsTrans";
import theme from "../../theme";
import { WhiteSpaceBody } from "../EnrollmentChangeCard/subcomponents";
import ResponsiveButton from "../subcomponents";
var PaperEnrollmentCard = function (_a) {
    var _b;
    var onEnroll = _a.onEnroll, is24HourError = _a.is24HourError, availableEnrollmentType = _a.availableEnrollmentType, enrollmentType = _a.enrollmentType;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var assets = useConfig().hosts.assets;
    var _d = useStatementsContext(), dispatch = _d.dispatch, accountId = _d.state.accountId;
    var accountSummary = useAccountSummary(accountId).data;
    var _e = useAccountFeatures(accountId), accountFeatures = _e.data, isAccountFeaturesError = _e.isError, isAccountFeaturesLoading = _e.isLoading;
    var selectedLanguage = i18n.language;
    var enrollErrorIcon = "".concat(assets).concat(endPoints.digitalAssets).concat(icons.errorIcon);
    var shouldShowPaperFee = getPaperFeeApplicable(accountFeatures);
    var paperFeeLetter = getPaperFeeMessage({
        applicableFee: shouldShowPaperFee,
        currentEnrollment: enrollmentType,
        enrollmentOption: availableEnrollmentType,
    });
    ToggleShowEnrollmentErrorHook(isAccountFeaturesLoading, shouldShowPaperFee, isAccountFeaturesError, dispatch);
    useEffect(function () {
        var _a;
        if (is24HourError) {
            triggerAnalytics({
                pageName: PAGE_NAME.REENROLLMENT_FAILED,
                pageSubFunction: "reenroll",
                errorMessage: t("modal.enroll.error24Hour", { lng: "en" }),
                messageType: "re-enroll error",
                clientName: (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _a === void 0 ? void 0 : _a.clientId,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [is24HourError, (_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _b === void 0 ? void 0 : _b.clientId]);
    return (_jsxs(NotEnrolledTemplate, { children: [is24HourError && (_jsxs(_Fragment, { children: [_jsx(MessageBox, __assign({ type: "error", role: "alertdialog", icon: _jsx(ErrorImage, { src: enrollErrorIcon }) }, { children: _jsx(Body, { children: t("modal.enroll.error24Hour") }) })), _jsx(Stack, { size: "large" })] })), _jsxs(NotEnrolledBody, { children: [_jsx(EnrollmentLogo, {}), _jsxs("div", { children: [_jsx(Body, __assign({ weight: "bold" }, { children: t("modal.enroll.title") })), _jsx(Stack, { size: "small" }), _jsx(WhiteSpaceBody, { children: _jsx(StatementsTrans, { i18nKey: "modal.paperLanguage.".concat(paperFeeLetter, ".text"), components: {
                                        strong: _jsx("strong", {}),
                                        consentLink: (_jsx(ConsentLink, { weight: "bold", href: getConsentLinks(selectedLanguage), target: "_blank", color: theme.cyanBlue })),
                                    } }) }), _jsx(Stack, { size: "large" }), _jsx(Small, { children: _jsx(StatementsTrans, { i18nKey: "modal.enroll.consent", components: {
                                        consentLink: (_jsx(ConsentLink, { href: getConsentLinks(selectedLanguage), target: "_blank", color: theme.brightBlue })),
                                    } }) }), _jsx(Stack, { size: "large" }), _jsx(ResponsiveButton, __assign({ buttonType: "primary", onClick: function () { return onEnroll(enrollmentTypes.PAPER); }, disabled: is24HourError, "data-type": "statements", "data-analytics": "clicktrackingevent", "data-reason": "go paperless", "data-object": "button" }, { children: t("modal.enroll.button") })), _jsx(Stack, { size: "small" })] })] })] }));
};
export default PaperEnrollmentCard;
